import React, { useEffect, useState } from "react"
import Layout from "../components/layout"
import { SSR_BASE_URL } from "../helpers/constants"
import styled from "styled-components"

const EventDetailFrame = styled.iframe`
  overflow: scroll;
  overflow-x: hidden;
  border: none;
  -ms-overflow-style: none;
  scrollbar-width: none;
  width: 100%;
  height: 100vh;
  & ::-webkit-scrollbar {
    display: none;
  }
`

const EventDetailBox = styled.div`
  display: flex;
  width: 100%;
  padding: 0;
  padding: 0 0 8rem 0;
  @media (min-width: 1280px) {
    padding: 0 0 4rem 0;
  }
`

const EventDetail = props => {
  let { id } = props
  const [eventId, setEventId] = useState("")
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    if (id) {
      setEventId(id)
    }
  })

  useEffect(() => {
    setMounted(true)
  }, [])

  return (
    <Layout {...props} minHeight="10rem" showFooterInMobile={false}>
      {mounted && (
        <EventDetailBox>
          {eventId && (
            <EventDetailFrame src={`${SSR_BASE_URL}/eventdetail/${eventId}`} />
          )}
        </EventDetailBox>
      )}
    </Layout>
  )
}

export default EventDetail
